import { Dropdown } from '@/components/ui'
import { RectangleHorizontal, RectangleVertical } from 'lucide-react'

export type VideoDimension = 'horizontal' | 'vertical'

interface DimensionsDropdownProps {
  value: VideoDimension
  onChange: (value: VideoDimension) => void
  disabled?: boolean
}

const options = [
  { value: 'horizontal', label: '1920 × 1080', description: 'Landscape', icon: <RectangleHorizontal className="size-4" /> },
  { value: 'vertical', label: '1080 × 1920', description: 'Portrait', icon: <RectangleVertical className="size-4" /> },
]

export function DimensionsDropdown({ value, onChange, disabled }: DimensionsDropdownProps) {
  return (
    <Dropdown
      label="Video Dimensions"
      value={value}
      onChange={(val) => onChange(val as VideoDimension)}
      options={options}
      disabled={disabled}
    />
  )
}
